import type { ProductCategory } from "../types/category";

export const MOCK_CATEGORIES: ProductCategory[] = [
  {
    id: "cat1",
    name: "OLED TVs",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "screen_size_inches",
          label: "Screen Size",
          type: "integer",
          unit: '"',
          sortOrder: "numeric_asc",
          displayFormat: '{value}"',
        },
      ],
      attributes: {
        display_technology: {
          type: "enum",
          values: ["OLED", "QD-OLED"],
          required: true,
        },
        resolution: {
          type: "enum",
          values: ["4K", "8K"],
          required: true,
        },
        refresh_rate_hz: {
          type: "integer",
          required: false,
        },
        smart_tv_platform: {
          type: "string",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 500,
    priceCeiling: 10000,
    productCount: 12,
  },
  {
    id: "cat2",
    name: "Mini-LED TVs",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "screen_size_inches",
          label: "Screen Size",
          type: "integer",
          unit: '"',
          sortOrder: "numeric_asc",
          displayFormat: '{value}"',
        },
      ],
      attributes: {
        display_technology: {
          type: "enum",
          values: ["Mini-LED", "Neo QLED", "QNED"],
          required: true,
        },
        resolution: {
          type: "enum",
          values: ["4K", "8K"],
          required: true,
        },
        refresh_rate_hz: {
          type: "integer",
          required: false,
        },
        dimming_zones: {
          type: "integer",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 400,
    priceCeiling: 10000,
    productCount: 10,
  },
  {
    id: "cat3",
    name: "QLED TVs",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "screen_size_inches",
          label: "Screen Size",
          type: "integer",
          unit: '"',
          sortOrder: "numeric_asc",
          displayFormat: '{value}"',
        },
      ],
      attributes: {
        resolution: {
          type: "enum",
          values: ["4K"],
          required: true,
        },
        refresh_rate_hz: {
          type: "integer",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 200,
    priceCeiling: 5000,
    productCount: 8,
  },
  {
    id: "cat4",
    name: "Crystal UHD TVs",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "screen_size_inches",
          label: "Screen Size",
          type: "integer",
          unit: '"',
          sortOrder: "numeric_asc",
          displayFormat: '{value}"',
        },
      ],
      attributes: {
        resolution: {
          type: "enum",
          values: ["4K"],
          required: true,
        },
        refresh_rate_hz: {
          type: "integer",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 100,
    priceCeiling: 2000,
    productCount: 6,
  },
  {
    id: "cat5",
    name: "LED/LCD TVs",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "screen_size_inches",
          label: "Screen Size",
          type: "integer",
          unit: '"',
          sortOrder: "numeric_asc",
          displayFormat: '{value}"',
        },
      ],
      attributes: {
        resolution: {
          type: "enum",
          values: ["4K", "1080p"],
          required: false,
        },
        refresh_rate_hz: {
          type: "integer",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 100,
    priceCeiling: 3000,
    productCount: 14,
  },
  // Multi-axis category to validate 2-axis coverage matrix rendering
  {
    id: "cat6",
    name: "Smartphones",
    parentId: null,
    attributeSchema: {
      variantAxes: [
        {
          key: "storage_gb",
          label: "Storage",
          type: "integer",
          unit: "GB",
          sortOrder: "numeric_asc",
          displayFormat: "{value} GB",
        },
        {
          key: "color",
          label: "Color",
          type: "enum",
          sortOrder: "alpha_asc",
          displayFormat: "{value}",
        },
      ],
      attributes: {
        os: {
          type: "string",
          required: true,
        },
        ram_gb: {
          type: "integer",
          required: false,
        },
        screen_size_inches: {
          type: "decimal",
          required: false,
        },
      },
    },
    useLineImageFallback: true,
    priceFloor: 200,
    priceCeiling: 2000,
    productCount: 0,
  },
];
